import { AdminReviewsClient } from './admin-reviews-client';

export const metadata = {
  title: 'Reviews · Alqove Admin',
};

export default function AdminReviewsPage() {
  return <AdminReviewsClient />;
}
